import React from 'react'
import PropTypes from 'prop-types'
import DefaultLayout from './DefaultLayout'
import NavigationBar from '../Navigation'
import DrawerContent from '../home/DrawerContent'

export default function PagesLayout({ children, navBarProps, ...props }) {
  return (
    <DefaultLayout
      navigationBar={
        <NavigationBar
          showDrawer
          drawerContent={<DrawerContent />}
          mainContent={children}
          {...navBarProps}
        />
      }
      {...props}
    />
  )
}

/**
 * All other props are passed to the DefaultLayout component
 *
 * @type {{children: *}}
 */
PagesLayout.propTypes = {
  /**
   * Anything that can be rendered
   */
  children: PropTypes.node,

  /**
   * Props to pass to the navigation bar
   */
  navBarProps: PropTypes.object,
}

PagesLayout.defaultProps = {
  children: null,
  navBarProps: {},
}
